module.exports = __webpack_public_path__ + "img/zxjg.a89841b9.jpg";